import {UseMutateFunction} from '@tanstack/react-query';
import {useAccountMutation, useAccountQuery} from "../accountQueries";
import {AccountSchema} from "../schemas/accountSchema";
import {SuccessResponseSchema} from "../schemas/successResponseSchema";
import {TransactionsSchema} from "../schemas/transactionsSchema";
import {useTransactionsMutation, useTransactionsQuery} from "../transactionsQueries";
import {AccountForm} from "../../ui/AccountStatementReportForm";
import {TransactionsForm} from "../../ui/TransactionsReportForm";

export interface TransactionsRequestResult {
    data: TransactionsSchema;
    isLoading: boolean;
    mutate: UseMutateFunction<SuccessResponseSchema, unknown, TransactionsForm, unknown>;
    isPending: boolean;
}

export interface AccountRequestResult {
    data: AccountSchema;
    isLoading: boolean;
    mutate: UseMutateFunction<SuccessResponseSchema, unknown, AccountForm, unknown>;
    isPending: boolean;
}

export interface UseReportsFormsRequestsResult {
    transactions: TransactionsRequestResult;
    account: AccountRequestResult;
}

export function useReportsFormsRequests(onSuccess: () => void): UseReportsFormsRequestsResult {
    const {data: transactionsData, isLoading: isTransactionsLoading} = useTransactionsQuery();
    const {mutate: mutateTransactions, isPending: isTransactionsPending} = useTransactionsMutation({onSuccess});

    const {data: accountData, isLoading: isAccountLoading} = useAccountQuery();
    const {mutate: mutateAccount, isPending: isAccountPending} = useAccountMutation({onSuccess});

    return {
        transactions: {
            data: transactionsData,
            isLoading: isTransactionsLoading,
            mutate: mutateTransactions,
            isPending: isTransactionsPending,
        },
        account: {
            data: accountData,
            isLoading: isAccountLoading,
            mutate: mutateAccount,
            isPending: isAccountPending,
        },
    };
}
